import type { Locale } from '@seek/melways-sites';
import { Box } from 'braid-design-system';
import { observer } from 'mobx-react';
import type React from 'react';

import type { PageConfig } from 'src/libs/PageConfig';
import type { TrackStatusUpdateAttributes } from 'src/utils/eventsTypes';

import type { ICandidateStore } from '../../../stores/JobApplicationStore/CandidateStore';

import Details from './Details';
import List from './List';

interface Props {
  candidateStore: ICandidateStore;
  locale: Locale;
  isVerifiedId: TrackStatusUpdateAttributes['isVerifiedId'];
  addCustomError: PageConfig['dataDogRum']['addCustomError'];
}

const PreviousApplicationsDesktop: React.FC<Props> = ({
  candidateStore,
  locale,
  isVerifiedId,
  addCustomError,
}) => {
  const {
    selectedPreviousApplication,
    previousApplications,
    selectPreviousApplication,
  } = candidateStore;

  return (
    <Box display="flex">
      <List
        previousApplications={previousApplications}
        selectedPreviousApplication={selectedPreviousApplication}
        selectPreviousApplication={selectPreviousApplication!}
        locale={locale}
        addCustomError={addCustomError}
      />
      <Details
        previousApplication={selectedPreviousApplication}
        locale={locale}
        isVerifiedId={isVerifiedId}
      />
    </Box>
  );
};

export default observer(PreviousApplicationsDesktop);
